import React from "react";
import "./ValuesTriangle.css";
import corevalue from "../../assets/Core-value.svg"; 

export default function ValuesTriangleSection() {
  return (
    <section className="vt-container">
      <div className="vt-wrapper">
        <img
          src={corevalue}
          alt="Values Triangle"
          className="vt-image"
        />
      </div>
    </section>
  );
}
